import DownArrowReport from './DownArrowReport';

export default DownArrowReport;
